import { render, staticRenderFns } from "./BottomSheetAddMailbox.vue?vue&type=template&id=73ac4856&scoped=true&"
import script from "./BottomSheetAddMailbox.vue?vue&type=script&lang=js&"
export * from "./BottomSheetAddMailbox.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetAddMailbox.vue?vue&type=style&index=0&id=73ac4856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ac4856",
  null
  
)

export default component.exports